/**
 *
 * @param {DOMMatrix} matrix
 * @param {Number} x
 * @param {Number} y
 */
function getTransformedPoint(matrix, x, y) {
  if (matrix) {
    const point = new DOMPoint(x, y).matrixTransform(matrix);
    return { x: point.x, y: point.y };
  }
  return { x, y };
}

export default getTransformedPoint;